import{j as e}from"./chunk-GEPA7FLG.js";e();import r,{useContext as n}from"react";var o=r.createContext(null);o.displayName="IoiomContext";function l(){let t=n(o);if(t==null)throw new Error("IoiomContext is null");return t}export{o as a,l as b};
//# sourceMappingURL=chunk-CLJZWHD2.js.map
